import { Box, SxProps, Typography } from "@mui/material";
import React from "react";

interface ChipProps {
  children?: React.ReactNode;
  backgroundColor?: string;
  color?: string;
  sx?: SxProps;
}

export const Chip = ({ children, backgroundColor, color, sx }: ChipProps) => {
  return (
    <Box
      sx={{
        backgroundColor: backgroundColor || "primary.main",
        color: color || "common.white",
        borderRadius: "20px",
        px: "8px",
        py: "4px",
        display: "flex",
        alignItems: "center",
        width: "fit-content",
        maxWidth: "100%",
        ...sx,
      }}
    >
      <Typography variant="preTitle">{children}</Typography>
    </Box>
  );
};
